import React from 'react';
import { GearConfigForm } from '@/components/config_forms/gear/GearConfigForm';
import { GearKitForm } from '@/components/config_forms/gear/GearKitForm';
import type { ClientFormData } from '../new_client/utilities/formDataUtils';
import type { ValidationError } from '@/utils/validation/types';
import type { GearConfig, GearItem, GearKit, CartageConfig } from '@/types/GearConfig';
import { DEFAULT_GEAR_CONFIG } from '@/types/GearConfig';

interface ClientGearConfigProps {
  formData: ClientFormData;
  handleChange: (field: keyof ClientFormData, value: unknown) => void;
  isCustomized?: boolean;
  onRevert?: () => void;
  errors?: ValidationError[];
  touchedFields?: Set<string>;
}

export const ClientGearConfig: React.FC<ClientGearConfigProps> = ({
  formData,
  handleChange,
}) => {
  const config: GearConfig = {
    gearItems: (formData.gear_items as GearItem[]) ?? DEFAULT_GEAR_CONFIG.gearItems,
    gearKits: (formData.gear_kits as GearKit[]) ?? DEFAULT_GEAR_CONFIG.gearKits,
    cartage: (formData.cartage as CartageConfig) ?? DEFAULT_GEAR_CONFIG.cartage,
    weekLengthDays: formData.gear_week_length_days ?? DEFAULT_GEAR_CONFIG.weekLengthDays,
  };

  const onConfigChange = (updated: GearConfig) => {
    handleChange('gear_items', updated.gearItems);
    handleChange('gear_kits', updated.gearKits);
    handleChange('cartage', updated.cartage);
    handleChange('gear_week_length_days', updated.weekLengthDays);
  };

  const onKitsChange = (kits: GearKit[]) => {
    handleChange('gear_kits', kits);
  };

  return (
    <div className="space-y-6">
      <GearConfigForm
        config={config}
        onChange={onConfigChange}
      />
      <GearKitForm
        kits={config.gearKits}
        availableItems={config.gearItems}
        onChange={onKitsChange}
      />
    </div>
  );
};
